import { render, staticRenderFns } from "./StaffView.vue?vue&type=template&id=352e99ba"
import script from "./StaffView.vue?vue&type=script&lang=js"
export * from "./StaffView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports